import { render } from "./IconGear.vue?vue&type=template&id=d4a22884"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconGear.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4a22884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4a22884', __exports__)) {
    api.reload('d4a22884', __exports__)
  }
  
  module.hot.accept("./IconGear.vue?vue&type=template&id=d4a22884", () => {
    api.rerender('d4a22884', render)
  })

}


export default __exports__